const StatusNotificationApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/status-notification/get`,
  POST: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/status-notification/create`,
  PUT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/status-notification/update`,
  DELETE: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/status-notification/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/status-notification/download`
}
 
export default StatusNotificationApiUrls
